import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Create, FileCopySharp, Add, Visibility } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { wsFindBy, wsUpdate } from 'services/WService.js';
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo', accessor: 'Periodo', width: 100 },
  { Header: 'Zona', accessor: 'zona', width: 120 },
  { Header: 'Código', accessor: 'codigo', width: 120 },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Grupo', accessor: 'group' },
  { Header: 'Cuota', accessor: 'quota', width: 180, excelEnabled: false },
  { Header: 'Cuota', accessor: 'quota_string', hidden: true },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function IndicatorsPanettone(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [indicadores, setIndicadores] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  const handleChange = (id, field, value) => {
    const index = indicadores.findIndex((item) => item.id == id);
    indicadores[index][field] = value;
    setIndicadores([...indicadores]);
  };

  async function loadIndicadores(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/panettone_indicators', filter);
    setDataLoading(false);
    if (response.success) setIndicadores(response.data);
  }

  async function updateIndicador(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/panettone_indicators', id, { Periodo: valueSearch.Periodo, [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      loadIndicadores(valueSearch);
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadIndicadores(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({ valueSearch })}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Indicadores Panetones{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadIndicadores}
              getValueSearch={(value) => setValueSearch(value)}
              date
              dateType="month"
              labelDate="Periodo"
              dateField="Periodo"
            />
            <ReactTable
              excelName="indicadores_panetones"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={indicadores.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}>
                        <Button justIcon round simple color="warning" onClick={() => setOpen({ ...item, valueSearch })}>
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_DELETED}>
                        <ButtonDelete
                          entity="sale/panettone_indicators"
                          id={item.id}
                          reload={() => {
                            setDataLoading(true);
                            loadIndicadores(valueSearch).then(() => setDataLoading(false));
                          }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  Periodo: item.Periodo,
                  zona: item.zona == 'NZ' ? 'Nazca' : item.zona == 'IC' ? 'Ica' : item.zona == 'CH' ? 'Chincha' : '',
                  codigo: item.codigo || '',
                  description: item.description,
                  group: item.sale_winter_panettone_group_product_id ? (
                    <div className="actions-right" style={{ display: 'flex', alignItems: 'center' }}>
                      <span>{item.group_product?.description || '—'}</span>
                      <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                        <Link to={`../grupo-productos/${item.sale_winter_panettone_group_product_id}`}>
                          <Visibility />
                        </Link>
                      </Button>
                    </div>
                  ) : '—',
                  group: item.sale_winter_panettone_group_product_id ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span>{item.group_product?.description || '—'}</span>
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_SHOW}
                      component={item.sale_winter_panettone_group_product_id}
                    >
                      <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                        <Link to={`../grupo-productos/${item.sale_winter_panettone_group_product_id}`}>
                          <Visibility />
                        </Link>
                      </Button>
                    </AllowedGuard>
                    </div>
                  ) : '—',
                  quota_string: item.quota,
                  quota: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.quota}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="cuota"
                        margin="normal"
                        value={item.quota || ''}
                        onChange={(e) => handleChange(item.id, 'quota', e.target.value)}
                        onBlur={(e) => updateIndicador(item.id, 'quota', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
